export const AUDIT_ROUTE = 'audit';
export const AUDIT_PARAM = 'code';
export const AUDIT_PARAM_SECONDARY = 'secondaryCode';
export const IMPORT = 'import';
export const HOME = 'home';
export const FORM_ROUTE = 'edit';
export const BACKUP = 'backup';
